import React from 'react';
import ProgressiveImage from 'react-progressive-graceful-image'

/**
 * The component load image progressivly
 * @param {img} img
 * @param {tiny} tiny
 * @param {alt} alt
 * @param {title} title 
 * @param {title} title 
 * @returns image with progressive loading
 */
const ProgressiveImg = (props) => {

  const {
    img,
    tiny,
    alt,
    title,
    classe,
    delay,
    imageFit

  } = props ;

  const fitImage = imageFit ? "image-fit" : ""

  return (
    <ProgressiveImage
      src={img}
      placeholder={tiny}
      delay={delay}
    >
      {(src, loading) => (
        <img 
          src={src} 
          className={`${fitImage} ${classe}`}
          title={title}
          alt={alt}
          // style={{ opacity: loading ? 0.5 : 1 }}
        />
      )}
    </ProgressiveImage>
  )
}

export default ProgressiveImg;
